/*
 * Entries that run on a different domain then where assets are served from, need an absolute public path.
 * Example: consumentenbond.nl loads assets from hypotheekadviesconsumentenbond.nl.
 * this file sets the webpack publicPath during runtime to point to the right domain for CBHS.
 * Should not be applied in Nuxt build, client and server
 */

if (process.env.VUE_ENV !== 'server' && !global.__NUXT__ && process.env.NODE_ENV === 'production' && __CBHS__) {
  __webpack_public_path__ = global.fritsVueEnvironment?.webpack?.publicPath
    ?? process.env.WEBPACK_PUBLIC_PATH;
}
